// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	// CTA Popup
	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});


	function checkScroll() {
		if ($(window).scrollTop() > 50) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}
	}

	checkScroll();
	$(window).on('scroll resize', checkScroll);


	// Menu
	const treatmentTrigger = document.querySelector('.treatment-menu-trigger');
	const treatmentMenu = document.querySelector('.desktop-menu-expand .treatment-menu');
	let hideTimeout;

	function showTreatmentMenu() {
		clearTimeout(hideTimeout);
		if (treatmentMenu) {
			treatmentMenu.classList.add('active');
			// Reposition menu based on header height if needed
			const header = document.querySelector('.desktop-menu');
			if (header) {
				treatmentMenu.style.top = header.offsetHeight + 'px';
			}
		}
	}

	function hideTreatmentMenu() {
		hideTimeout = setTimeout(() => {
			if (treatmentMenu) {
				treatmentMenu.classList.remove('active');
			}
		}, 50);
	}

	if (treatmentTrigger && treatmentMenu) {
		treatmentTrigger.addEventListener('mouseenter', showTreatmentMenu);
		treatmentTrigger.addEventListener('mouseleave', hideTreatmentMenu);

		treatmentMenu.addEventListener('mouseenter', showTreatmentMenu);
		treatmentMenu.addEventListener('mouseleave', hideTreatmentMenu);
	};


	// Reuse existing treatmentMenu variable from your hover code
	var clickTrigger = document.querySelector('.click-treatment-menu-trigger');

	if (clickTrigger && treatmentMenu) {

		clickTrigger.addEventListener('click', function(e) {
			e.preventDefault();

			// Toggle menu visibility
			var isActive = treatmentMenu.classList.contains('active');
			if (isActive) {
				treatmentMenu.classList.remove('active');
			} else {
				treatmentMenu.classList.add('active');

				// Reposition menu below header
				var header = document.querySelector('.desktop-menu');
				if (header) {
					treatmentMenu.style.top = header.offsetHeight + 'px';
				}
			}
		});

		// Close menu if clicking outside
		document.addEventListener('click', function(e) {
			if (treatmentMenu.classList.contains('active') &&
				!treatmentMenu.contains(e.target) &&
				!clickTrigger.contains(e.target)) {
				treatmentMenu.classList.remove('active');
			}
		});
	}


	const triggerOpen = document.querySelector('.trigger-open');
	const triggerClose = document.querySelector('.trigger-close');
	const mobileMenu = document.querySelector('.mobile-menu-expand');
	const wrapperNavbar = document.getElementById('wrapper-navbar');
	const treatmentMobileTrigger = document.querySelector('.click-treatment-mobile-menu-trigger');

	if (triggerOpen && triggerClose && mobileMenu && wrapperNavbar) {

		// Existing burger menu open/close
		triggerOpen.addEventListener('click', function () {
			mobileMenu.classList.add('active');
			wrapperNavbar.classList.add('mobile-menu-active');
			triggerOpen.classList.add('d-none');
			triggerClose.classList.remove('d-none');
		});

		triggerClose.addEventListener('click', function () {
			mobileMenu.classList.remove('active');
			wrapperNavbar.classList.remove('mobile-menu-active');
			triggerOpen.classList.remove('d-none');
			triggerClose.classList.add('d-none');
		});

		// Click treatment button to open menu and expand submenu
		if (treatmentMobileTrigger) {
			treatmentMobileTrigger.addEventListener('click', function () {
				// Open the mobile menu if not already open
				if (!mobileMenu.classList.contains('active')) {
					mobileMenu.classList.add('active');
					wrapperNavbar.classList.add('mobile-menu-active');
					triggerOpen.classList.add('d-none');
					triggerClose.classList.remove('d-none');
				}

				// Expand the specific submenu
				const submenuLi = document.querySelector('.mobile-menu-trigger.menu-item-has-children');
				if (submenuLi) {
					// Find the toggle link
					const toggleLink = submenuLi.querySelector('.dropdown-toggle.nav-link');
					if (toggleLink) {
						toggleLink.classList.add('show'); // Add show to link
					}

					// Also add show to the submenu <ul>
					const submenuUl = submenuLi.querySelector('ul');
					if (submenuUl) {
						submenuUl.classList.add('show'); // Add show to <ul>
					}
				}
			});
		}
	}



	// Sliders
	$('.testimonial-carousel.slick-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		fade: true,
		speed: 600,
		dots: false,
		arrows: true,
		prevArrow: $('.arrow-left'),
		nextArrow: $('.arrow-right')
	});

	if ($('.accreditations-carousel').length > 0) {
		$('.accreditations-carousel').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			arrows: false,
			fade: false,
			autoplay: true,
			autoplaySpeed: 0,
			cssEase: 'linear',
			speed: 4000,
			pauseOnHover: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});

		// Fix vertical alignment after Slick initializes
		$('.accreditations-carousel').on('setPosition', function () {
			$(this).find('.slick-slide').css('height', 'auto'); // reset heights
			var maxHeight = 0;
			$(this).find('.slick-slide').each(function () {
				if ($(this).outerHeight() > maxHeight) {
					maxHeight = $(this).outerHeight();
				}
			});
			$(this).find('.slick-slide').css('height', maxHeight + 'px'); // force uniform height
		});
	}

	// $('.accreditations-carousel.slick-slider').slick({
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	autoplay: true,
	// 	autoplaySpeed: 8000,
	// 	arrows: false,
	// 	dots: false,
	// 	infinite: false,
	// 	variableWidth: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 991,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });

	$('.treatments-slider').slick({
		slidesToShow: 3,
		centerMode: true,
		centerPadding: '10%',
		dots: false,
		infinite: true,
		speed: 500,
		arrows: true,
		prevArrow: $('.treatment-arrow-left'),
		nextArrow: $('.treatment-arrow-right'),
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});


	var $slider = $('.before-after-slider');
	var $descriptions = $('.before-after-description-slide');

	// Initialize slider
	$slider.slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		dots: false,
		arrows: true,
		adaptiveHeight: true,
		prevArrow: $('.before-afters-arrow-left'),
		nextArrow: $('.before-afters-arrow-right'),
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	// Hide all descriptions except the first
	$descriptions.hide().eq(0).show().addClass('active');

	// On slide change, update description
	$slider.on('afterChange', function(event, slick, currentSlide){
		$descriptions.hide().removeClass('active');
		$descriptions.eq(currentSlide).show().addClass('active');
	});


	const treatmentVideoSlider = $('.videos-slider');

	treatmentVideoSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		infinite: false,
		adaptiveHeight: false,
		prevArrow: $('.treatment-video-arrow-left'),
		nextArrow: $('.treatment-video-arrow-right')
	});

	$('.video-wrapper').on('click', 'lite-youtube, lite-vimeo', function() {
		$(this).siblings('.video-play-icon').hide();
	});




	// Accordion

	$('.accordion-header').on('click', function() {

		var item = $(this).closest('.accordion-item');
		var answer = item.find('.accordion-answer');
		var icon = $(this).find('i');

		// Close others
		$('.accordion-answer').not(answer).slideUp().addClass('d-none');
		$('.accordion-header i').not(icon).removeClass('fa-minus').addClass('fa-plus');

		// Toggle this one
		answer.slideToggle().toggleClass('d-none');
		icon.toggleClass('fa-plus fa-minus');
	});


	// Select 2
	jQuery(function ($) {
		$('.init-select2 select').select2({
			width: '100%',
			placeholder: 'Select an option',
			allowClear: true
		});
	});


});
